import React from "react";

import { useDispatch, useSelector } from "react-redux";
import {
    executeAction,
    executeDownload,
    executeDownloadFolder,
    isLoading,
    isSecondaryLoading,
    getData,
    getFormSuccess,
} from "../../../../redux/actions/manager/job/files";

import FileManager from "../../../../components/fileManager/main";

const Browse = (props) => {
    const dispatch = useDispatch();

    const onExcuteAction = (form) => dispatch(executeAction(props.id, form));
    const onExcuteDownload = (path, name) => dispatch(executeDownload(props.id, path, name));
    const onExcuteDownloadFolder = (path, name) => dispatch(executeDownloadFolder(props.id, path, name));

    const loading = useSelector(isLoading);
    const secondaryLoading = useSelector(isSecondaryLoading);
    const data = useSelector(getData);

    return (
        <FileManager
            storage={props.storage}
            defaults={props.defaults}
            templates={props.templates}
            onCreateStorage={props.onCreateStorage}
            allowCreate
            allowRename
            allowUpload
            allowDelete
            data={data}
            loading={loading}
            secondaryLoading={secondaryLoading}
            executeAction={onExcuteAction}
            executeDownload={onExcuteDownload}
            executeDownloadFolder={onExcuteDownloadFolder}
        />
    );
};

export default Browse;
